export const BILLING_ROUTE_PREFIX = '/billing'
export const BILLING_SUCCESS_ROUTE = '/billing-success'
export const HOME_ROUTE = '/home'
